import type {
  AllTagsItem,
  DiscoverTagRef,
  ProductRef,
  TrendingTag,
} from "../types";

type ExploreTagLike =
  | Pick<AllTagsItem, "slug">
  | DiscoverTagRef
  | Pick<TrendingTag, "slug">;
type ExploreProductLike = Pick<ProductRef, "slug">;

export function buildExploreToolHref({
  exploreBase,
  productSlug,
}: {
  exploreBase: string;
  productSlug: string;
}): string {
  return `${exploreBase}/tools/${encodeURIComponent(productSlug)}`;
}

export function buildExploreTagHref({
  exploreBase,
  tagSlug,
}: {
  exploreBase: string;
  tagSlug: string;
}): string {
  return `${exploreBase}/tags/${encodeURIComponent(tagSlug)}`;
}

export function buildExploreToolHrefForProduct({
  exploreBase,
  product,
}: {
  exploreBase: string;
  product: ExploreProductLike;
}): string {
  return buildExploreToolHref({
    exploreBase,
    productSlug: product.slug,
  });
}

export function buildExploreTagHrefForTag({
  exploreBase,
  tag,
}: {
  exploreBase: string;
  tag: ExploreTagLike;
}): string {
  return buildExploreTagHref({
    exploreBase,
    tagSlug: tag.slug,
  });
}

export function buildExploreSkillHref({
  exploreBase,
  skillSlug,
}: {
  exploreBase: string;
  skillSlug: string;
}): string {
  return `${exploreBase}/skills/${encodeURIComponent(skillSlug)}`;
}
